import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Observable, ReplaySubject, Subject, throwError} from 'rxjs';
import { catchError, first, take } from 'rxjs/operators';
import { Uuid } from '../interface/response/uuid';
import { CountedAndPaginated } from '../interface/response/counted-and-paginated';
import {FilterService} from "./filter.service";
import {WarehouseProduct} from "../interface/warehouse-product";
import {Note} from "../interface/note";
import {ListResponse} from "../interface/response/list-response";
import {AdditionalField} from "../interface/additionalField";

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {
  private readonly productsListSubject: ReplaySubject<CountedAndPaginated<WarehouseProduct>>
    = new ReplaySubject<CountedAndPaginated<WarehouseProduct>>(1);
  private readonly productsListSubjects: ReplaySubject<ListResponse<WarehouseProduct>>
    = new ReplaySubject<ListResponse<WarehouseProduct>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {}

  public loadList(page: number, pageSize: number, filters: object): void {


    this.httpClient.get(`/rest/crm/product?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<WarehouseProduct>) => {
        this.productsListSubject.next(result);
      });
  }

  public getProduct(uuid: string): Observable<WarehouseProduct> {
    return this.httpClient.get(`/rest/crm/product/${uuid}`)
      .pipe(first()) as Observable<WarehouseProduct>;
  }

  public addProduct(formData: object): Observable<Uuid> {
    return this.httpClient.post<Uuid>('/rest/crm/product', formData)
      .pipe(take(1));
  }

  public updateProduct(uuid: string, updatedProduct: Partial<WarehouseProduct>): Observable<WarehouseProduct> {
    return this.httpClient.put<WarehouseProduct>(`/rest/crm/product/${uuid}`, updatedProduct)
      .pipe(first());
  }

  public deleteProduct(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/product/${uuid}`)
      .pipe(first());
  }

  downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/product/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public getProductsListSubject(): ReplaySubject<CountedAndPaginated<WarehouseProduct>> {
    return this.productsListSubject;
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object, subject?: Subject<ListResponse<WarehouseProduct>>): void {
    this.httpClient
      .get(`/rest/crm/product?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<WarehouseProduct>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.productsListSubjects.next(result);
        }
      });
  }

  public updateImage(uuid: string, fileBase64: any): Observable<any> {
    return this.httpClient.put(`/rest/crm/product/${uuid}/image`, {
      content: fileBase64
    }).pipe(first());
  }

  public deleteImage(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/product/${uuid}/deleteFile`)
      .pipe(first());
  }
}
